import React, { memo, useEffect, useState } from 'react';
import { Table } from 'antd';

import Header from './selectBox';
import Dot from './dot';
import colors from './colors';
import { delay } from '@utils/common';
import { Loading, NoData } from '@components';

import {
  filterData,
  getYearOptions,
  getYearsCateOptions,
  getYearsCateValue,
} from './utils';

const columns = [
  {
    dataIndex: 'year',
    title: 'year',
    width: '4.5rem',
    align: 'center',
  },
  {
    key: 'key',
    dataIndex: 'category',
    title: 'key',
    width: '5rem',
    align: 'center',
    render: (text) => <Dot color={colors[text - 1]} />,
  },
  {
    dataIndex: 'categoryLabel',
    title: 'category',
    width: '16rem',
    align: 'left',
  },
  {
    dataIndex: 'news',
    title: 'news',
    align: 'left',
  },
];

const getScrollYHeight = () => ({ y: document.body.clientHeight - 260 });

function FullscreenHistorytabel({
  dataSource,
  years = [],
  categories = [],
  yearsWithCateId = {},
}) {
  const [filters, ChangeFilters] = useState({});
  const [isLoading, toggleLoading] = useState(false);
  const [data, setData] = useState([]);

  const asyncChangeData = ({ time = 400, dataSource = [], filters = {} }) => {
    toggleLoading(true);

    delay(() => setData(filterData(dataSource, filters)), time).finally(() =>
      toggleLoading(false),
    );
  };
  const handleChangeFilter = (value = {}) => {
    const newFilters = { ...value };

    if (newFilters.year.length !== filters.year.length) {
      newFilters.category = getYearsCateValue({
        years: newFilters.year,
        categories,
      });
    }

    ChangeFilters(newFilters);

    asyncChangeData({
      time: 200,
      filters: newFilters,
      dataSource,
    });
  };

  useEffect(() => {
    if (years.length > 0) {
      ChangeFilters({
        ...filters,
        year: years,
        category: getYearsCateValue({
          years,
          categories,
        }),
      });
    }
  }, [categories, years]);

  useEffect(() => {
    if (dataSource.length < 100) {
      return setData(dataSource);
    }
    asyncChangeData({
      dataSource,
      filters,
    });
  }, [dataSource]);

  if (!dataSource?.length > 0) {
    return <NoData />;
  }

  return (
    <div className="company-history-table-wrapper">
      <Header
        // isLoading={isLoading}
        filters={filters}
        expand
        onChange={handleChangeFilter}
        yearOptions={getYearOptions(years)}
        categoryOptions={getYearsCateOptions({
          years: filters.year,
          categories,
          yearsWithCateId,
        })}
      />

      <Table
        loading={{ indicator: <Loading />, spinning: isLoading }}
        pagination={false}
        className="company-history-table"
        columns={columns}
        dataSource={data}
        scroll={getScrollYHeight()}
      />
    </div>
  );
}

FullscreenHistorytabel.propTypes = {};

export default memo(FullscreenHistorytabel);
